import { z } from "zod";

/**
 * Contact scopé à UN bien (collaborateurSrs / expertPeb / prestataireEle),
 * renvoyé par le RPC `get_bien_contacts` (migration 126). Volontairement
 * minimal : jamais toute la table `profiles`, jamais un rôle sans lien avec
 * ce bien précis (cf. commentaire de la migration).
 */
export const BienContactSchema = z.object({
  id: z.string(),
  first_name: z.string().nullable().optional(),
  last_name: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  telephone: z.string().nullable().optional(),
});
export type BienContact = z.infer<typeof BienContactSchema>;
